import { z } from "zod";

export const CreateChatSchema = z.object({
  projectId: z.string().min(1).nullable().optional()
});

export const UpdateChatProjectSchema = z.object({
  projectId: z.string().min(1).nullable()
});

export const UpdateChatShareSchema = z.object({
  shared: z.boolean()
});

export type CreateChatInput = z.infer<typeof CreateChatSchema>;
export type UpdateChatProjectInput = z.infer<typeof UpdateChatProjectSchema>;
export type UpdateChatShareInput = z.infer<typeof UpdateChatShareSchema>;
